// extracted by mini-css-extract-plugin
export default {"expirationOptions":"IVzc3PAGiRlPOolLkt4y"};